import { on, toggleClass } from '../helpers/shortcuts';
import shared from './shared';

export default () => {
  const header = document.querySelector('.c-header');

  if (header === null) {
    return;
  }
  const headerHamburger = header.querySelector('.c-header__hamburger');

  if (headerHamburger) {
    on('click', headerHamburger, event => {
      event.preventDefault();
      toggleClass(document.documentElement, shared.CSS.menuOpen);
    });
  }
};



// WEBPACK FOOTER //
// ./src/scripts/modules/header.js